export const LOAD_PURCHASE_METHODS_SUCCESS = 'LOAD_PURCHASE_METHODS_SUCCESS';

export const SELECT_PURCHASE_METHOD = 'SELECT_PURCHASE_METHOD';
export const SELECT_PAYMENT_FREQUENCY = 'SELECT_PAYMENT_FREQUENCY';
export const SELECT_TERM = 'SELECT_TERM';
export const SELECT_KM_PLAN = 'SELECT_KM_PLAN';

export const SET_CASH_DOWN = 'SET_CASH_DOWN';
export const SET_TRADE_IN = 'SET_TRADE_IN';
export const SET_LIEN = 'SET_LIEN';
export const SET_EXTERIOR_COLOUR_AMOUNTS = 'SET_EXTERIOR_COLOUR_AMOUNTS';
export const SET_INTERIOR_COLOUR_AMOUNTS = 'SET_INTERIOR_COLOUR_AMOUNTS';
export const SET_OPTIONS_AMOUNTS = 'SET_OPTIONS_AMOUNTS';

export const SET_DELIVERY_FEE = 'SET_DELIVERY_FEE';
export const SET_DEPOSIT = 'SET_DEPOSIT';

export const SET_TAXES_INCLUDED = 'SET_TAXES_INCLUDED';

export const SELECT_OPTIONS_RESOLUTION = 'SELECT_OPTIONS_RESOLUTION';

export const RESET_SELECTED_INCENTIVE_REBATES = 'RESET_SELECTED_INCENTIVE_REBATES';

export const QUOTE_UPDATE_TYPES = [
    SELECT_PURCHASE_METHOD,
    SELECT_PAYMENT_FREQUENCY,
    SELECT_TERM,
    SELECT_KM_PLAN,
    SET_CASH_DOWN,
    SET_TRADE_IN,
    SET_LIEN,
    SET_TAXES_INCLUDED,
    SELECT_OPTIONS_RESOLUTION,
];

export default {
    LOAD_PURCHASE_METHODS_SUCCESS,
    SELECT_PURCHASE_METHOD,
    SELECT_PAYMENT_FREQUENCY,
    SELECT_TERM,
    SELECT_KM_PLAN,
    SET_CASH_DOWN,
    SET_TRADE_IN,
    SET_LIEN,
    SET_EXTERIOR_COLOUR_AMOUNTS,
    SET_INTERIOR_COLOUR_AMOUNTS,
    SET_OPTIONS_AMOUNTS,
    SET_DELIVERY_FEE,
    SET_DEPOSIT,
    SET_TAXES_INCLUDED,
    SELECT_OPTIONS_RESOLUTION,
    RESET_SELECTED_INCENTIVE_REBATES,
    QUOTE_UPDATE_TYPES,
};



// WEBPACK FOOTER //
// ./src/PurchaseMethods/actions/purchaseMethodsActionTypes.js